export default "<div class=\"bg\"></div>"